import { GET_REPORT_DATA } from './mutation-types'
import relatorioDiretoOperadorHttpService from '../_services/relatorioDiretoOperadorHttpService'

export default {
  gerarRelatorioResumidoSaidaOperador: async ({ commit }, form) => {
    try {
      const [responseTotal, responseDiaCorrido, responseMediaDia, responseHora, responseMediaHora] = await Promise.all([
        relatorioDiretoOperadorHttpService.getRelatorioResumidoSaidaOperadorTotal(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoSaidaOperadorDiaCorrido(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoSaidaOperadorMediaDia(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoSaidaOperadorHora(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoSaidaOperadorMediaHora(form),
      ])

      const responseData = []
      for (let i = 0; i < responseTotal.data.length; i++) {
        responseData.push(
          Object.assign(
            {},
            responseTotal.data[i],
            responseDiaCorrido.data[i],
            responseMediaDia.data[i],
            responseHora.data[i],
            responseMediaHora.data[i]
          )
        )
      }
      commit(GET_REPORT_DATA, responseData)
    } catch (e) {
      console.log(e)
    }
  },
}
